import { memo } from 'react';

export interface FilePlaceholderWithFilterProps {
  onClearFilter: () => void;
}

const FilesPlaceholderWithFilter = ({ onClearFilter }: FilePlaceholderWithFilterProps) => (
  <div className="text-center text-muted padding-top margin-top">
    {translate('No files were found to match your search.')}
    <br />
    {translate('You can modify filter criteria or')}
    &nbsp;
    <a className="margin-top" title="start upload" onClick={onClearFilter}>
      {translate('clear filter.')}
    </a>
    <br />
    <br />
  </div>
);

// eslint-disable-next-line import/no-default-export
export default memo(FilesPlaceholderWithFilter);
